import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Progress from 'components/common/Progress';

const styles = () => ({
  root: {
    position: 'relative',
    height: '100%',
  },
});

class DocumentsViewPdf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  componentWillMount() {
    fetch(this.props.src).then(() => {
      this.setState({ loading: false });
      this.props.onLoad();
    });
  }

  render() {
    const { loading } = this.state;
    const { classes, src } = this.props;
    return (
      <div className={classes.root}>
        {loading ? (
          <Progress />
        ) : (
          <object
            data={`${src}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0`}
            type="application/pdf"
            width="100%"
            height="100%"
          >
            PDF is not supported in your browser, please, download file to open
          </object>
        )}
      </div>
    );
  }
}

DocumentsViewPdf.propTypes = {
  src: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentsViewPdf.defaultProps = {
  onLoad: () => {},
};

export default withStyles(styles)(DocumentsViewPdf);



// WEBPACK FOOTER //
// ./src/components/common/DocumentsViewDialog/DocumentsViewPdf.js